import { SearchEngine } from './types/Engine';
import { SearchEngineGeneratorProps } from './types/EngineGeneratorProps';

export const createSearchEngine = ({
  safeParam,
  isSearch,
}: SearchEngineGeneratorProps): SearchEngine => {
  return {
    isSafeSearchActive: (url: URL): boolean => {
      return url.searchParams.get(safeParam.key) === safeParam.value;
    },
    getSafeSearchUrl: (url: URL): string => {
      url.searchParams.set(safeParam.key, safeParam.value);
      return url.toString();
    },
    isSearch,
  };
};
